<div class="container-fluid">
	<h1 class="text-capitalize mt-3">{{user.id ? 'Actualizar':'Agregar'}} Proveedor</h1>
	<form ngNativeValidate (submit)="save()" name="save-user-form">
		<div class="card p-3">
			<div class="row p-3">
				<div class="col-12 col-sm-2 col-lg-1">
					<label class="">Imagen</label>
					<app-image-uploader [(image)]="user.image_id"></app-image-uploader>
				</div>
				<div class="col-12 col-sm-10">
					<div class="row">
						<div class="col-12 col-md-3 form-group">
							<label class="">Código</label>
							<input type="text" name="code" [(ngModel)]="user.code" class="form-control" placeholder="PROV-001">
						</div>
						<div class="col-12 col-md-5 form-group">
							<label class="">Nombre</label>
							<input type="text" name="name" [(ngModel)]="user.name" class="form-control" required>
						</div>
						<div class="col-12 col-md-4 form-group">
							<label class="">Teléfono</label>
							<input type="text" name="phone" [(ngModel)]="user.phone" class="form-control">
						</div>
						<div class="col-12 col-md-6 form-group">
							<label class="">Correo electrónico</label>
							<input type="email" name="email" [(ngModel)]="user.email" class="form-control">
						</div>
						<div class="col-12 col-md-3 form-group" *ngIf="user.id">
							<label>Estatus</label>
							<select name="status" class="form-control" [(ngModel)]="user.status">
								<option value="ACTIVE">Activo</option>
								<option value="DELETED">Inactivo</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>

		<h2 class="my-3">Datos fiscales</h2>
		<div class="card p-3">
			<div class="row">
				<div class="col-12 col-md-3 form-group">
					<label>RFC</label>
					<input type="text" name="rfc" [(ngModel)]="address.rfc" class="form-control text-uppercase" maxlength="13" placeholder="XAXX010101000">
				</div>
				<div class="col-12 col-md-6 form-group">
					<label>Razón social</label>
					<input type="text" name="razon_social" [(ngModel)]="address.name" class="form-control" list="provider_name_suggestion">
					<datalist id="provider_name_suggestion">
						<option>{{user.name}}</option>
					</datalist>
				</div>
				<div class="col-12 col-md-3 form-group">
					<label>Régimen capital</label>
					<input type="text" name="sat_regimen_capital" [(ngModel)]="address.sat_regimen_capital" placeholder="SA de CV" class="form-control">
				</div>
				<div class="col-12 col-md-6 form-group">
					<label>Régimen fiscal</label>
					<select class="form-control" name="sat_regimen_fiscal" [(ngModel)]="address.sat_regimen_fiscal">
						<option [ngValue]="null">Seleccionar</option>
						<option *ngFor="let r of sat_regimen_fiscal_list" [value]="r.code">{{r.code}} - {{r.name}}</option>
					</select>
				</div>
				<div class="col-12 col-md-6 form-group">
					<label>Dirección</label>
					<input type="text" name="address" [(ngModel)]="address.address" class="form-control" placeholder="Calle y número">
				</div>
				<div class="col-12 col-md-3 form-group">
					<label>Colonia</label>
					<input type="text" name="suburb" [(ngModel)]="address.suburb" class="form-control">
				</div>
				<div class="col-12 col-md-3 form-group">
					<label>Código postal</label>
					<input type="text" name="zipcode" [(ngModel)]="address.zipcode" class="form-control" maxlength="5">
				</div>
				<div class="col-12 col-md-3 form-group">
					<label>Ciudad</label>
					<input type="text" name="city" [(ngModel)]="address.city" class="form-control">
				</div>
				<div class="col-12 col-md-3 form-group">
					<label>Estado</label>
					<input type="text" name="state" [(ngModel)]="address.state" class="form-control" list="state_suggestion">
					<datalist id="state_suggestion">
						<option *ngFor="let s of states">{{s}}</option>
					</datalist>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-12 text-end">
					<button type="submit" [disabled]="is_loading" class="btn btn-primary">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 20 20"><path d="M15.173 2H4c-1.101 0-2 .9-2 2v12c0 1.1.899 2 2 2h12c1.101 0 2-.9 2-2V5.127L15.173 2zM14 8c0 .549-.45 1-1 1H7c-.55 0-1-.451-1-1V3h8v5zm-1-4h-2v4h2V4z" fill="currentColor"/></svg>
						Guardar
					</button>
				</div>
			</div>
		</div>
	</form>
</div>
